import React from 'react';
import cn from 'classnames';
import { IBaseElementProps } from '../BasicElement';
import VHSQuote, { IVHSQuoteProps } from '../VHSQuote';
export interface IVHSBlockQuoteProps extends IBaseElementProps {
	/**
	 * Heading
	 */
	heading?: string;
	/**
	 * Quote
	 */
	quote?: IVHSQuoteProps;
}

/**
 * Block Quote
 * @block
 * @icon sticky
 */
const VHSBlockQuote: React.FC<IVHSBlockQuoteProps> = ({
	heading,
	quote,
	className,
	classNames = [],
}) => (
	<div className={className || cn('vhs-block-quote', ...classNames)}>
		<div className="vhs-block-quote__container">
			{heading && <h2 className="vhs-block-quote__heading">{heading}</h2>}
			{quote && (
				<VHSQuote
					{...quote}
					className="vhs-block-quote__quote"
				/>
			)}
		</div>
	</div>
);

export default VHSBlockQuote;
